<template>
  <v-card
    v-intersect="onIntersect"
    class="d-sm-flex align-sm-center text-center text-sm-left item"
    color="transparent"
    flat
    tile
  >
    <img
      class="d-block d-sm-inline-block mx-auto mx-sm-0 item-img"
      :src="files + img + '?resize=1&h=65'"
    />

    <div class="mt-1 text-shadow">
      <div
        v-if="title"
        class="
          white--text
          text-subtitle-1 text-md-h6 text-center text-sm-left
          font-weight-medium
          mt-3
        "
      >
        {{ title }}
      </div>

      <div
        v-if="number"
        class="
          white--text
          text-h4 text-md-h3 text-center text-sm-left
          font-weight-bold
        "
        ref="amount"
      >
        0
      </div>

      <div
        v-if="text"
        class="
          white--text
          text-subtitle-1 text-md-h6 text-center text-sm-left
          font-weight-medium
        "
      >
        {{ text }}
      </div>
    </div>
  </v-card>
</template>

<script>
export default {
  props: {
    img: {
      type: String,
      required: true,
    },
    title: {
      type: String,
      default: "",
    },
    text: {
      type: String,
      default: "",
    },
    number: {
      type: Number,
      required: true,
    },
  },
  methods: {
    formatNumber(v) {
      return new Intl.NumberFormat("pt-BR").format(v);
    },
    goAnimate() {
      const start = 0;
      const end = this.number;
      const duration = 2000;

      const obj = this.$refs.amount;
      const range = end - start;
      const minTimer = 50;
      let stepTime = Math.abs(Math.floor(duration / range));

      stepTime = Math.max(stepTime, minTimer);

      const startTime = new Date().getTime();
      const endTime = startTime + duration;
      let timer = null;

      const run = () => {
        const now = new Date().getTime();
        const remaining = Math.max((endTime - now) / duration, 0);
        const value = Math.round(end - remaining * range);
        obj.innerHTML = this.formatNumber(value);
        if (value == end) {
          clearInterval(timer);
        }
      };

      timer = setInterval(run, stepTime);
      run();
    },
    onIntersect(entries) {
      if (entries[0].isIntersecting) {
        this.goAnimate();
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.item {
  gap: 30px;

  &-img {
    height: 65px;
    max-width: 100px;
    -o-object-fit: contain;
    object-fit: contain;
    pointer-events: none;
  }
}
</style>
